import { Link } from "react-router-dom";
import { fmtDate } from "@/lib/format";
import { Card, CardContent } from "@/components/ui/card";

export const RecentImportsCard = ({ data }) => (
  <div>
    <div className="flex items-center justify-between mb-5">
      <h2 className="text-2xl sm:text-3xl font-serif font-semibold">Recent imports</h2>
      <Link to="/imports" className="text-sm text-primary hover:underline" data-testid="view-all-imports-link">View all</Link>
    </div>
    <Card className="shadow-sm">
      <CardContent className="p-0">
        {!data || data.recent_imports.length === 0 ? (
          <p className="text-muted-foreground text-sm p-8" data-testid="no-imports-message">
            No imports yet. When you upload your first order file, it will show up here.
          </p>
        ) : (
          <ul className="divide-y divide-border" data-testid="recent-imports-list">
            {data.recent_imports.map((b) => (
              <li key={b.id} className="flex flex-wrap items-center justify-between gap-2 px-6 py-4">
                <div>
                  <p className="font-medium text-sm">{b.filename}</p>
                  <p className="text-xs text-muted-foreground">{fmtDate(b.uploaded_at)} · by {b.uploaded_by_email}</p>
                </div>
                <p className="text-sm text-muted-foreground">
                  {b.status === "rolled_back"
                    ? <span className="text-destructive">Undone</span>
                    : `${b.orders_added} orders · ${b.new_customers} new customers · ${b.duplicates_skipped} duplicates skipped`}
                </p>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  </div>
);
